import { useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const FLAG = 'tapelligence-demo-mode';
const INTERVAL_MS = 5 * 60 * 1000;

// Invisible: keeps a super admin Demo-mode session alive. Renders nothing.
const DemoHeartbeat = () => {
  useEffect(() => {
    const beat = () => {
      if (localStorage.getItem(FLAG) !== 'true') return;
      fetch(`${API_URL}/api/auth/heartbeat`, { method: 'POST', credentials: 'include' })
        .then(r => (r.ok ? r.json() : { enabled: false }))
        .then(d => { if (!d.enabled) localStorage.removeItem(FLAG); })
        .catch(() => {});
    };
    const onVisible = () => { if (document.visibilityState === 'visible') beat(); };
    beat();
    const id = setInterval(beat, INTERVAL_MS);
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', onVisible); };
  }, []);
  return null;
};

export default DemoHeartbeat;
